import { Controller } from '@hotwired/stimulus'

// Keep MAX_BYTES in sync with Upload::MAX_IMAGE_SIZE.
const MAX_BYTES = 10 * 1024 * 1024

export default class extends Controller {
  static targets = ['area', 'input', 'filename', 'error', 'submit']

  click() {
    this.inputTarget.click()
  }

  dragover(event) {
    event.preventDefault()
    this.areaTarget.classList.add('border-primary', 'bg-base-200')
  }

  dragleave(event) {
    event.preventDefault()
    this.areaTarget.classList.remove('border-primary', 'bg-base-200')
  }

  drop(event) {
    event.preventDefault()
    this.areaTarget.classList.remove('border-primary', 'bg-base-200')

    const { files } = event.dataTransfer
    if (files.length > 0) {
      this.inputTarget.files = files
      this.accept(files[0])
    }
  }

  fileSelected() {
    const { files } = this.inputTarget
    if (files.length > 0) {
      this.accept(files[0])
    }
  }

  accept(file) {
    this.showFilename(file.name)

    if (file.size > MAX_BYTES) {
      const megabytes = (file.size / (1024 * 1024)).toFixed(1)
      this.showError(
        `That file is ${megabytes} MB. The limit is ${MAX_BYTES / (1024 * 1024)} MB — please upload a smaller file.`
      )
    } else {
      this.clearError()
    }
  }

  showFilename(name) {
    this.filenameTarget.textContent = name
    this.filenameTarget.classList.remove('hidden')
  }

  showError(message) {
    this.errorTarget.textContent = message
    this.errorTarget.classList.remove('hidden')
    this.submitTarget.disabled = true
  }

  clearError() {
    this.errorTarget.textContent = ''
    this.errorTarget.classList.add('hidden')
    this.submitTarget.disabled = false
  }
}
